import { defineStore } from 'pinia';
import { optimizeJobPhotoUrls } from '@/composables/useOptimizedPhotoUrl';

export const useRecommendedJobsStore = defineStore({
  id: 'useRecommendedJobsStore',
  state: () => {
    return {
      currentPage: 0,
      currentPageIndex: 0,
      error: null,
      jobs: [],
      loading: false,
      orderIds: [],
      pagination: {
        first: true,
        last: false,
        number: 0,
        numberOfElements: 17,
        size: 50,
        totalElements: 0,
        totalPages: 1,
      },
      rowsPerPage: '50',
    };
  },
  actions: {
    setOrderIds(orderIds) {
      this.orderIds = orderIds;
    },
    async fetchRecommendedJobs(orderIds) {
      this.loading = true;
      this.error = null;
      this.jobs = [];

      const body = { orderIds };

      try {
        const { $api } = useNuxtApp();
        const response = await $api('api/transport-requests/available', {
          method: 'POST',
          body,
          params: {
            // page: this.number,
            // size: rowsPerPage.value,
          },
        });

        const responseContent = response.data.content;
        const responsePagination = response.data.pagination;
        this.jobs = optimizeJobPhotoUrls(this.filterJobsWithoutRequestId(responseContent));
        this.pagination = this.updatePaginationObject(responseContent, responsePagination);
      } catch (error) {
        this.error = error;
      } finally {
        this.loading = false;
      }
    },
    filterJobsWithoutRequestId(jobsArray) {
      // handles the case where a job id is associated with a bundle and the API response contains a bundle object instead of a job
      // https://acvauctions.atlassian.net/browse/TRA-7185
      return jobsArray.filter((job) => job.requestId);
    },
    updatePaginationObject(responseContent, responsePagination) {
      // update the pagination object in the case where bundles were filtered out
      if (responseContent.length > this.jobs.length) {
        responsePagination.numberOfElements = this.jobs.length;
        responsePagination.totalElements = this.jobs.length;
      }
      return responsePagination;
    },
  },
});
